<template>
  <div class="lesson-view-modern">
      
        <header class="modern-header" role="banner">
              <div class="header-content">
                <button class="back-btn" @click="goBack" aria-label="Go back">
                  <i class="bi bi-arrow-left" aria-hidden="true"></i>
                </button>
                <div class="header-text text-dark">
                  <h1 class="course-title">{{ lesson.name }}</h1>
                  <p class="course-subtitle">{{course.name}}</p>
                </div>
              </div>
            </header>
        
        

    

    <!-- Video Player Section -->
    <section class="video-section" aria-label="Video lesson" v-if="lesson.videoUrl">
      <div class="video-container">
        <video
          ref="videoElement"
          :src="videoSrc"
          controls
          controlsList="nodownload"
          playsinline
          webkit-playsinline
          disablePictureInPicture
  @click="enterFullscreen"
          @contextmenu.prevent
          @loadedmetadata="onVideoLoad"
          @timeupdate="onTimeUpdate"
          @ended="onVideoEnd"
          class="video-player"
          :poster="lesson.thumbnail || course.image"
        >
          <source :src="videoSrc" type="video/mp4">
          Your browser does not support the video tag.
        </video>
        
        <!-- Video Overlay -->
        <div class="video-overlay" v-if="!isPlaying && currentTime === 0">
          <button class="play-overlay-btn" @click="togglePlay" aria-label="Play video">
            <i class="bi bi-play-fill"></i>
          </button>
        </div>
        
        <!-- Progress Bar -->
        <div class="video-progress-bar" v-if="duration > 0">
          <div class="progress-fill" :style="{ width: videoProgress + '%' }"></div>
        </div>
      </div>
    </section>


        <section class="pdf-section" aria-label="PDF lesson" v-else>
        <div class="pdf-container">
          <!-- <object
            :data="notesPath"
            type="application/pdf"
            width="100%"
            height="600px"
          >
            <p>Your browser does not support PDFs.
              <a :href="notesPath" target="_blank">Download the PDF</a>
            </p> -->
    
        <iframe
         ref="pdfFrame"
  :src="'https://docs.google.com/gview?url=' + encodeURIComponent(notesPath) + '&embedded=true'"
  width="100%"
  height="600px"
   frameborder="0"
    :class="{ fullscreen: isFullScreen }"
></iframe>

        </div>


      </section>

       <!-- </object> -->
        <div class="text-center" v-if ="lesson.notesPath">
                <button @click="toggleFullScreen2" class="fs-btn-second">
      {{ isFullScreen ? 'Exit Full Screen' : 'Full Screen' }}
    </button>

                  <!-- Exit Full Screen Button -->
      <button
  
        v-if="isFullScreen"
        @click="toggleFullScreen2"
        class="exit-btn"
      >
        ✕ Exit
      </button>
      </div>





    <!-- Navigation Tabs -->
    <section class="tabs-section">
      <div class="tab-buttons">
        <button 
          class="tab-btn" 
          :class="{ active: currentTab === 1 }" 
          @click="currentTab = 1"
          aria-label="Lesson details tab"
        >
          <i class="bi bi-info-circle"></i>
          <span>Details</span>
        </button>
        <button 
          class="tab-btn" 
          :class="{ active: currentTab === 2 }" 
          @click="currentTab = 2"
          aria-label="Course lessons tab"
        >
          <i class="bi bi-collection-play"></i>
          <span>Lessons</span>
        </button>
      </div>
    </section>

    <!-- Tab Content -->
    <main class="tab-content" role="main">
      <!-- Details Tab -->
      <div class="tab-panel" v-show="currentTab === 1" aria-labelledby="details-heading">
        <div class="content-card">
          <div class="card-header">
            <div class="header-icon">
              <i class="bi bi-file-text"></i>
            </div>
            <h2 id="details-heading" class="card-title">Lesson Details</h2>
          </div>
          
          <div class="lesson-meta">
            <div class="meta-item" v-if="course.lessons && course.lessons > 0">
              <i class="bi bi-collection"></i>
              <span>{{ course.lessons }} Total Lessons</span>
            </div>
            <div class="meta-item" v-if="lesson.minutes">
              <i class="bi bi-clock"></i>
              <span>{{ lesson.minutes }} minutes</span>
            </div>
          </div>
          
          <div class="lesson-description" v-if="lesson.description">
            <div v-html="lesson.description"></div>
          </div>
          
          <div class="empty-description" v-else>
            <p>No description available for this lesson.</p>
          </div>
        </div>
      </div>

      <!-- Lessons Tab -->
      <div class="tab-panel" v-show="currentTab === 2" aria-labelledby="lessons-heading">
        <div class="content-card">
          <div class="card-header">
            <div class="header-icon">
              <i class="bi bi-play-btn"></i>
            </div>
            <h2 id="lessons-heading" class="card-title">Course Lessons</h2>
          </div>
          
          <div class="lessons-list" v-if="courseLessons.length > 0">
            <div 
              class="lesson-item" 
              v-for="(courseLesson, index) in courseLessons" 
              :key="courseLesson.id"
              @click="selectLesson(courseLesson)"
              :class="{ 
                'current': courseLesson.id === lesson.id,
                'locked': courseLesson.status === 'locked',
                'completed': courseLesson.status === 'completed'
              }"
            >
              <div class="lesson-number">{{ index + 1 }}</div>
              <div class="lesson-icon">
                <i class="bi bi-play-fill" v-if="courseLesson.status !== 'locked'"></i>
                <i class="bi bi-lock-fill" v-else></i>
              </div>
              <div class="lesson-content">
                <h3 class="lesson-name">{{ courseLesson.name }}</h3>
                <div class="lesson-duration" v-if="courseLesson.minutes">
                  <i class="bi bi-clock"></i>
                  <span>{{ courseLesson.minutes }} min</span>
                </div>
              </div>
              <div class="lesson-status">
                <i class="bi bi-check-circle-fill" v-if="courseLesson.status === 'completed'"></i>
                <i class="bi bi-play-circle" v-else-if="courseLesson.id === lesson.id"></i>
              </div>
            </div>
          </div>
          
          <div class="empty-lessons" v-else>
            <div class="empty-icon">
              <i class="bi bi-collection"></i>
            </div>
            <p>No lessons available</p>
          </div>
        </div>
      </div>
    </main>

    <!-- Enroll CTA -->
    <div class="enroll-cta" v-if="course.enrolled === 'No'">
      <router-link :to="'/cart?id='+course.id" class="enroll-btn" aria-label="Enroll in course">
        <div class="cta-content">
          <span class="cta-price">₹{{ course?.cost }}</span>
          <span class="cta-text">Enroll Now</span>
        </div>
        <i class="bi bi-arrow-right"></i>
      </router-link>
    </div>
    
    
  </div>
</template>
<style scoped>
.fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 9999;
}
.exit-btn {
  position: absolute;
  top: 10px;
  left: 22px;
  padding: 6px 12px;
  background: red;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  z-index: 10000;
}
.fs-btn {
  margin-bottom: 10px;
  padding: 6px 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.fs-btn-second {
  margin-bottom: 10px;
  padding: 6px 12px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;

    margin: 10px 0;
}
iframe{
  width: -webkit-fill-available;
    height: -webkit-fill-available;
}
.pdf-container {
  position: relative;
  width: 100%;
  height: 600px; /* apni requirement ke hisaab se */
  border: 1px solid #ddd;
  border-radius: 10px;
  overflow: hidden;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
}


.modern-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(26, 26, 46, 0.95);
  padding: 10px;
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.course-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.course-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0;
}


.lesson-view-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  color: white;
}

.lesson-header {
     display: flex
;
    align-items: center;
    gap: 1rem;
    max-width: 1200px;
    margin: 0 auto;
    background: rgba(26, 26, 46, .95);
    padding: 10px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.back-btn {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.header-text {
  flex: 1;
}

.lesson-title {
  color: white;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

.course-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  margin: 0;
}

.lesson-progress {
  background: rgba(255, 255, 255, 0.1);
  padding: 0.5rem 1rem;
  border-radius: 50px;
  backdrop-filter: blur(10px);
}

.progress-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.video-section {
  padding: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.video-container {
  position: relative;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background: #000;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
}

.video-player {
  width: 100%;
  height: auto;
  aspect-ratio: 16/9;
  display: block;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.play-overlay-btn {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a1a2e;
  font-size: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.play-overlay-btn:hover {
  transform: scale(1.1);
  background: white;
}

.video-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transition: width 0.3s ease;
}

.tabs-section {
  padding: 0 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.tab-buttons {
  display: flex;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 4px;
  backdrop-filter: blur(20px);
}

.tab-btn {
  flex: 1;
  background: transparent;
  border: none;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.tab-btn.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  backdrop-filter: blur(10px);
}

.tab-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.9);
}

.tab-content {
  padding: 1.5rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
}

.tab-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.content-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 1.5rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: white;
  margin: 0;
}

.lesson-meta {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.meta-item i {
  color: #667eea;
}

.lesson-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.empty-description {
  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  padding: 2rem;
  font-style: italic;
}

.lessons-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.lesson-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
}

.lesson-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.lesson-item.current {
  background: rgba(102, 126, 234, 0.2);
  border-color: rgba(102, 126, 234, 0.5);
}

.lesson-item.locked {
  opacity: 0.5;
  cursor: not-allowed;
}

.lesson-item.locked:hover {
  transform: none;
  background: rgba(255, 255, 255, 0.05);
}

.lesson-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  flex-shrink: 0;
}

.lesson-item.current .lesson-number {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.lesson-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.lesson-item.locked .lesson-icon {
  background: rgba(255, 255, 255, 0.2);
}

.lesson-content {
  flex: 1;
}

.lesson-name {
  font-size: 1rem;
  font-weight: 600;
  color: white;
  margin: 0 0 0.25rem;
  line-height: 1.3;
}

.lesson-duration {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
}

.lesson-status i {
  font-size: 1.2rem;
  color: #27ae60;
}

.empty-lessons {
  text-align: center;
  padding: 3rem 1rem;
  color: rgba(255, 255, 255, 0.5);
}

.empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  font-size: 2rem;
  color: rgba(255, 255, 255, 0.3);
}

.enroll-cta {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: rgba(26, 26, 46, 0.95);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
}

.enroll-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  padding: 1rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.enroll-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.5);
  color: white;
}

.cta-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cta-price {
  font-size: 1.2rem;
  font-weight: 800;
}

.cta-text {
  font-size: 0.9rem;
  opacity: 0.9;
}

@media (min-width: 768px) {
  .lesson-header {
    padding: 1.5rem 2rem;
  }
  
  .video-section {
    padding: 2rem;
  }
  
  .tabs-section {
    padding: 0 2rem;
  }
  
  .tab-content {
    padding: 2rem;
  }
  
  .content-card {
    padding: 2rem;
  }
  
  .lesson-item {
    padding: 1.25rem;
  }
  
  .lesson-title {
    font-size: 1.5rem;
  }
  
  .enroll-cta {
    padding: 1.5rem 2rem;
  }
}

@media (max-width: 576px) {
  .header-content {
    gap: 0.75rem;
  }
  
  .lesson-title {
    font-size: 1.1rem;
  }
  
  .lesson-progress {
    display: none;
  }
  
  .tab-btn span {
    display: none;
  }
  
  .lesson-meta {
    flex-direction: column;
    gap: 1rem;
  }
  
  .lesson-item {
    padding: 0.75rem;
  }
  
  .lesson-number {
    width: 28px;
    height: 28px;
    font-size: 0.75rem;
  }
  
  .lesson-icon {
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
}
</style>
<script>
import { ref, computed, nextTick, getCurrentInstance } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axios from '@/plugins/axios'

export default {
  name: 'LessonView',
  data() {
    return {
      currentTab: 1,
      isPlaying: false,
      isMuted: false,
      showControls: true,
      currentTime: 0,
      duration: 0,
      videoProgress: 0,
      courseProgress: 75,
      lesson: {},
      notes: [],
      course: {},
      courseLessons: [],
      videoSrc: '',
      notesPath:'',
      videoElement: null,
        isFullScreen: false,
    }
  },
  computed: {
    lessonNumber() {
      return this.courseLessons.findIndex(l => l.id === this.lesson.id) + 1
    },
    totalLessons() {
      return this.courseLessons.length
    },
    hasPreviousLesson() {
      return this.lessonNumber > 1
    },
    hasNextLesson() {
      return this.lessonNumber < this.totalLessons
    }
  },
  watch: {
    '$route.query.lesson'(newLesson, oldLesson) {
      if (newLesson !== oldLesson) {
        const courseId = this.$route.query.cource
        const lessonId = this.$route.query.lesson
        this.getHomeBasic(courseId, lessonId)
      }
    }
  },
  methods: {
       async enterFullscreen() {
            const video = this.$refs.videoElement;
        
            // 1. Enter fullscreen
            try {
              if (video.requestFullscreen) await video.requestFullscreen();
              else if (video.webkitRequestFullscreen) await video.webkitRequestFullscreen();
            } catch (e) {
              console.warn("Fullscreen failed", e);
            }
        
            // 2. Rotate to landscape if possible
            if (screen.orientation && screen.orientation.lock) {
              try {
                await screen.orientation.lock('landscape');
              } catch (e) {
                console.warn("Orientation lock failed", e);
              }
            }
          },
    goBack() {
      this.$router.replace(`/course?id=${this.course.id}`)
    },
    selectLesson(selectedLesson) {
    
      if (this.course.enrolled === 'No' && selectedLesson.is_paid === 'Yes') {
        this.$swal.fire('This lesson is paid. Please enroll for this course.')
        return;
      }else{
          this.$router.push({
              path: '/lesson',
              query: {
                course: this.course.id,
                lesson: selectedLesson.id
              }
            }).then(() => {
              window.location.reload();
            });
      }

    //   this.$router.push(`/lesson?cource=${this.course.id}&lesson=${selectedLesson.id}`)
    //   window.location.reload();
    },
    navigateToLesson(navLesson) {
      if (navLesson.status === 'locked') {
        this.$swal.fire('This lesson is locked. Complete previous lessons first.')
        return
      }
      this.$router.push(`/lesson?cource=${this.course.id}&lesson=${navLesson.id}`)
    },
    previousLesson() {
      if (this.hasPreviousLesson) {
        const prevLesson = this.courseLessons[this.lessonNumber - 2]
        this.$router.push(`/lesson?cource=${this.course.id}&lesson=${prevLesson.id}`)
      }
    },
    nextLesson() {
      if (this.hasNextLesson) {
        const nextLesson = this.courseLessons[this.lessonNumber]
        if (nextLesson.status === 'locked') {
          this.$swal.fire('Complete the current lesson to unlock the next one.')
          return
        }
        this.$router.push(`/lesson?cource=${this.course.id}&lesson=${nextLesson.id}`)
      }
    },
    onVideoLoad() {
      if (this.videoElement) this.duration = this.videoElement.duration;
      this.isPlaying=!this.isPlaying;
    },
    onTimeUpdate() {
      if (this.videoElement) {
        this.currentTime = this.videoElement.currentTime
        this.videoProgress = (this.videoElement.currentTime / this.videoElement.duration) * 100 || 0
      }
    },
    onVideoEnd() {
      this.isPlaying = false
      this.markLessonComplete()
    },
    togglePlay() {
      if (!this.videoElement) return
      if (this.isPlaying) this.videoElement.pause()
      else this.videoElement.play()
      this.isPlaying = !this.isPlaying
    },
    toggleMute() {
      if (!this.videoElement) return
      this.videoElement.muted = !this.videoElement.muted
      this.isMuted = this.videoElement.muted
    },
    toggleFullscreen() {
      const video = this.videoElement
      if (!video) return
      if (video.requestFullscreen) video.requestFullscreen()
      else if (video.webkitRequestFullscreen) video.webkitRequestFullscreen()
      else if (video.msRequestFullscreen) video.msRequestFullscreen()
    },
    formatTime(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins}:${secs.toString().padStart(2, '0')}`
    },
    markLessonComplete() {
      this.lesson.status = 'completed'
      this.$swal.fire('Lesson completed! Great job!')
    },
    async getHomeBasic(courceid = 0, lessonId = 0) {
   

      try {
        const response = await axios.post('getLessonDetails', { courceid, lesson: lessonId })
        if (response.data?.logged) {
          this.course = response.data.cource_details || {}
          this.courseLessons = response.data.lessons || []
          this.lesson = response.data.lesson_details || {}
          this.videoSrc = this.lesson.videoUrl;// `https://edutechapp.dktechs.in/edutech/index.php/api/video/${lessonId}`
          this.notesPath = this.lesson.notesPath;

          
          
        }
      } catch (err) {
        alert(err?.response?.data?.message || 'Something went wrong. Please try again.')
        console.log(err)
      }
    },


  toggleFullScreen2() {

      this.isFullScreen = !this.isFullScreen;
    },










  },
  mounted() {
    nextTick(() => {
      if (this.videoElement) {
        this.videoElement.addEventListener('contextmenu', e => e.preventDefault())
        this.videoElement.addEventListener('keydown', e => {
          if (e.ctrlKey || e.metaKey) e.preventDefault()
        })
      }
      const courseId = this.$route.query.course
      const lessonId = this.$route.query.lesson
      this.getHomeBasic(courseId, lessonId)
    })
  }
}
</script>
 